export default __webpack_public_path__ + "static/media/iris.f57ae6f6.jpg";